import { useMemo } from 'react';
import { uniq } from 'lodash/array';
import { isEmpty } from 'lodash/lang';

import { TRAVEL_TOPIC } from 'components/root/Container/Layout/Tasks/Task/taskConstants';

import {
  ROLE_CLINICAL_QUALITY_COORDINATOR,
  ROLE_OPERATIONS_ANALYST,
  ROLE_PATIENT_LIAISON,
  ROLE_TRAVEL_COORDINATOR
} from '../../../../../../constants/userRoles';
import { rolesAccessToPageMap } from '../../../CurrentUserContainer';

export default function useFilteredAssignees(allAssignees, access, matchedSsuIds, topicType) {
  return useMemo(
    function() {
      return filterAssigneesBySsuIdsIfPresent(filterAssigneesByAccess(allAssignees, access), matchedSsuIds, topicType);
    },
    [allAssignees, access, matchedSsuIds, topicType]
  );
}

function filterAssigneesByAccess(assignees, access) {
  const allowedRoles = uniq(access?.flatMap(a => rolesAccessToPageMap[a]));
  return assignees?.filter(({ roles }) => roles.some(({ role }) => allowedRoles.includes(role)));
}

function filterAssigneesBySsuIdsIfPresent(assignees, matchedSsuIds, topicType) {
  if (!topicType) return assignees;
  if (topicType === TRAVEL_TOPIC) {
    return assignees?.filter(({ roles }) => roles.map(e => e.role).includes(ROLE_TRAVEL_COORDINATOR));
  } else {
    return resolveAssigneesForRegularTopic(matchedSsuIds, assignees);
  }
}

function resolveAssigneesForRegularTopic(matchedSsuIds, assignees) {
  if (isEmpty(matchedSsuIds))
    return assignees.filter(({ roles }) => !roles.map(e => e.role).includes(ROLE_TRAVEL_COORDINATOR));
  return assignees?.filter(({ ssuIds, roles }) => isWithAllowedRoleAndSsuId(matchedSsuIds, ssuIds, roles));
}

function isWithAllowedRoleAndSsuId(matchedSsuIds, ssuIds, roles) {
  const skipByRole = roles.some(({ role }) =>
    [ROLE_CLINICAL_QUALITY_COORDINATOR, ROLE_OPERATIONS_ANALYST, ROLE_PATIENT_LIAISON].includes(role)
  );

  const hasOnlyTravelCoordinatorRole = roles.length === 1 && roles[0].role === ROLE_TRAVEL_COORDINATOR;
  return (
    !hasOnlyTravelCoordinatorRole &&
    (skipByRole || ssuIds.includes(null) || matchedSsuIds.some(id => ssuIds.includes(id)))
  );
}
